// eslint-disable-next-line @typescript-eslint/no-empty-object-type
type BaseValueType = boolean | number | string | {} | null | undefined | void;

/**
 * Infers a mutable tuple type. This isn't really required anymore because TS mostly supports tuples and named tuples.
 *
 * @example
 * const ALL_SUITS = tuple('hearts', 'diamonds', 'spades', 'clubs');
 * type AllSuits = typeof ALL_SUITS; // same as: type AllSuits = ['hearts', 'diamonds', 'spades', 'clubs']
 * type Suit = AllSuits[number];  // same as: type Suit = 'hearts' | 'diamonds' | 'spades' | 'clubs';
 * // Alternatively you can use `as const`
 * const ALL_SUITS = ['hearts', 'diamonds', 'spades', 'clubs'] as const
 * @param args - The value of the tuple
 * @returns A typed tuple
 */
export function tuple<T extends BaseValueType[]>(...args: T): T {
    return args;
}
